let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4Ytwp")).then(() => parcelRequire('iO13U'));